module.exports = __webpack_public_path__ + "static/img/banner-4.6f61f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-4.png
// module id = SBXo
// module chunks = 1